import { useEffect, useRef, useState } from "react";
import ServiceCategoryCard from "./services/ServiceCategoryCard";
import SectionHeading from "./SectionHeading";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import { Navigation } from "swiper/modules";
import { CategoryAPI } from "../api";
import { Link } from "react-router-dom";
const ServiceSlider = () => {
	const prevRef = useRef(null);
	const nextRef = useRef(null);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		CategoryAPI.getAllCategories()
			.then((res) => setCategories(res.data))
			.catch((err) => console.error(err));
	}, []);

	return (
		<div className="">
			<div className="d-flex justify-content-between align-items-center ">
				<SectionHeading title={"Our Services"} />
				<div className="d-flex">
					<button ref={prevRef} className="slider-button">
						<i className="bi bi-chevron-left"></i>
					</button>
					<button ref={nextRef} className="slider-button">
						<i className="bi bi-chevron-right"></i>
					</button>
				</div>
			</div>
			<Swiper
				modules={[Navigation]}
				breakpoints={{
					// When window width is >= 1024px
					1024: {
						slidesPerView: 4,
					},
					// When window width is >= 768px
					768: {
						slidesPerView: 3,
					},
					// When window width is < 768px
					0: {
						slidesPerView: 1,
					},
				}}
				spaceBetween={30}
				onInit={(swiper) => {
					// Connect navigation buttons after swiper is ready
					swiper.params.navigation.prevEl = prevRef.current;
					swiper.params.navigation.nextEl = nextRef.current;
					swiper.navigation.init();
					swiper.navigation.update();
				}}
				className="mySwiper"
			>
				{categories.map((category, index) => (
					<SwiperSlide>
						<Link className="text-decoration-none h-100" key={index} to={`/services/${category.slug}`}>
							<ServiceCategoryCard
								image={category.icon_url}
								title={category.title}
								short_description={category.short_description}
							/>
						</Link>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default ServiceSlider;
